import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreenSizeService } from '../../../../services/utils/screenSize.service';
import { OtpService } from '../../../auth/services/otp.service';

@Component({
    selector: 'app-verify-number',
    templateUrl: './verify-number.component.html',
    styleUrls: ['../../verify-request/verify-request.component.css'],
    standalone: false
})
export class VerifyNumberComponent implements OnInit {

  phoneNumber: string = '';
  isVerified: boolean = false;
  wentWrong: boolean = false;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    protected screenSize: ScreenSizeService,
    private otpService: OtpService
  ) {
    this.activatedRoute.queryParams.subscribe(async params => {
      this.phoneNumber = params['phoneNumber'] ?? '';
      const token = params['token'];

      if (!token) {
        // No token: nothing to verify (e.g. page opened directly).
        return;
      }

      try {
        await this.otpService.verifySmsLink(token);
        this.isVerified = true;
      } catch (error) {
        console.error('Phone verification failed:', error);
        this.wentWrong = true;
      }
    });
  }

  ngOnInit() {
  }

  toDashboard(){
    this.router.navigate(['/']);
  }

}